import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';


import { API_LINK, STORAGE_LINK } from '../../constants';
import { turnitinDoSubmissionFailure, turnitinDoSubmissionRequest, turnitinDoSubmissionSuccess } from '../reducers/turnitin';
import {
  buildTurnitinSubmissionPayload,
  resolveTurnitinAssessmentContext,
} from '../../utils/buildTurnitinSubmissionPayload';

const API = `${API_LINK}api`;

function* turnitinUploadFunctionAxios() {
  const state = yield select(fullState => fullState);
  const { statementid, request_id, doc_url, eulaVersion, eulaAcceptedTimestamp, eulaLanguage } = state.turnitinReducer;
  const {
    user,
    token,
  } = state.loginReducer;

  const assessmentContext = resolveTurnitinAssessmentContext(state);
  const eula = eulaVersion && eulaAcceptedTimestamp
    ? {
      version: eulaVersion,
      accepted_timestamp: eulaAcceptedTimestamp,
      language: eulaLanguage,
    }
    : null;
  const data = JSON.stringify(
    buildTurnitinSubmissionPayload({ user, assessmentContext, request_id, eula }),
  );

  const response = yield call(() =>
    axios({
      method: 'put',
      url: API+'/assessor/tii_submission',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Uploaaded-With': 'XMLHttpUploaad',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        tii_data: data,
        statementid: statementid,
        url: STORAGE_LINK+doc_url
      },
    }),
  );

  return response;
}

function* workerTurnitinUploadSaga() {
  try {
    const response = yield call(turnitinUploadFunctionAxios);
    const responseFromTurnitinUpload = response.data;
    if (response.status === 200) {
      yield put(turnitinDoSubmissionSuccess(responseFromTurnitinUpload));
    }
    if (response.status === 201) {
      yield put(turnitinDoSubmissionFailure(responseFromTurnitinUpload.message));
    }
  } catch (error) {
    yield put(turnitinDoSubmissionFailure(error.message));
  }
}

export function* watcherTurnitinUploadSaga() {
  yield takeLatest(turnitinDoSubmissionRequest().type, workerTurnitinUploadSaga);
}
